export default {
  data () {
    return {
      valid: false,
      emailRules: [
        v => !!v || 'E-mail is required',
        v =>
          /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(v) ||
          'E-mail must be valid'
      ],
      itemRules: [v => !!v || 'is required'],
      datesRules: [v => (v && v.length >= 1) || 'is required'],
      passwordRules: [v => !!v || 'is required'],
      currencyRules: [
        v => v === '' || !v || /^-?[0-9]*\.?[0-9]*$/.test(v) || 'is not valid'
      ]
    }
  }
}
